copyLength